/**
 * @generated SignedSource<<4aa9e5250bc2038de0d10c246f152222>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type JiraProjectStyle = "COMPANY_MANAGED_PROJECT" | "TEAM_MANAGED_PROJECT" | "%future added value";
export type JiraProjectType = "BUSINESS" | "CUSTOMER_SERVICE" | "PRODUCT_DISCOVERY" | "SERVICE_DESK" | "SOFTWARE" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type SpacePicker_data$data = {
  readonly jira: {
    readonly allJiraProjects: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly avatar: {
            readonly medium: string | null | undefined;
          } | null | undefined;
          readonly key: string;
          readonly name: string;
          readonly projectId: string | null | undefined;
          readonly projectStyle: JiraProjectStyle | null | undefined;
          readonly projectType: JiraProjectType | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly smarts: {
    readonly recommendedContainerV2: ReadonlyArray<{
      readonly container: {
        readonly avatar?: {
          readonly medium: string | null | undefined;
        } | null | undefined;
        readonly key?: string;
        readonly name?: string;
        readonly projectId?: string | null | undefined;
        readonly projectStyle?: JiraProjectStyle | null | undefined;
        readonly projectType?: JiraProjectType | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "SpacePicker_data";
};
export type SpacePicker_data$key = {
  readonly " $data"?: SpacePicker_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"SpacePicker_data">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "ScalarField",
    "name": "projectId"
  },
  {
    "kind": "ScalarField",
    "name": "name"
  },
  {
    "kind": "ScalarField",
    "name": "key"
  },
  {
    "concreteType": "JiraAvatar",
    "kind": "LinkedField",
    "name": "avatar",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "medium"
      }
    ]
  },
  {
    "kind": "ScalarField",
    "name": "projectType"
  },
  {
    "kind": "ScalarField",
    "name": "projectStyle"
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    },
    {
      "defaultValue": 20,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "tenantId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "name": "SpacePicker_data",
  "selections": [
    {
      "concreteType": "JiraQuery",
      "kind": "LinkedField",
      "name": "jira",
      "plural": false,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "cloudId",
              "variableName": "cloudId"
            },
            {
              "kind": "Literal",
              "name": "filter",
              "value": {
                "keyword": "",
                "sortBy": {
                  "order": "DESC",
                  "sortBy": "LAST_ISSUE_UPDATED_TIME"
                },
                "types": [
                  "BUSINESS",
                  "SOFTWARE"
                ]
              }
            },
            {
              "kind": "Variable",
              "name": "first",
              "variableName": "first"
            }
          ],
          "concreteType": "JiraProjectConnection",
          "kind": "LinkedField",
          "name": "allJiraProjects",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraProjectEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "JiraProject",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": (v0/*: any*/)
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "concreteType": "SmartsQueryApi",
      "kind": "LinkedField",
      "name": "smarts",
      "plural": false,
      "selections": [
        {
          "args": [
            {
              "fields": [
                {
                  "fields": [
                    {
                      "kind": "Literal",
                      "name": "product",
                      "value": "jira"
                    },
                    {
                      "kind": "Variable",
                      "name": "tenantId",
                      "variableName": "tenantId"
                    },
                    {
                      "kind": "Variable",
                      "name": "userId",
                      "variableName": "userId"
                    }
                  ],
                  "kind": "ObjectValue",
                  "name": "context"
                },
                {
                  "kind": "Literal",
                  "name": "maxNumberOfResults",
                  "value": 10
                },
                {
                  "kind": "Literal",
                  "name": "modelRequestParams",
                  "value": {
                    "caller": "team-invite-people",
                    "experience": "CgContainerNearbyUser"
                  }
                },
                {
                  "kind": "Literal",
                  "name": "requestingUserId",
                  "value": "context"
                }
              ],
              "kind": "ObjectValue",
              "name": "recommendationsQuery"
            }
          ],
          "concreteType": "SmartsRecommendedContainerV2",
          "kind": "LinkedField",
          "name": "recommendedContainerV2",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "name": "container",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": (v0/*: any*/),
                  "type": "JiraProject"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "c64deba9d28bfb68c7ec60c105af1f73";

export default node;
